module.exports = __webpack_public_path__ + "media/images/flags/16/North-Korea-dbf34c18ef82874d7edb8b54fd43fd12.png";